<template>
  <a class="pointer edit" @click="click" v-c-tooltip.hover.click="'Edit'">
    <CIcon name="cil-pen" /> {{ label }}
  </a>
</template>
<script>
export default {
  props: ["label"],
  methods: {
    click() {
      this.$emit("click");
    },
  },
};
</script>